import {
  type HttpClient,
  parseContentDispositionFileName,
  type RequestConfig,
} from '@mathflat/domain/http/client'
import axios, { type AxiosInstance } from 'axios'

// maxios 가 아닌 axios 인스턴스(AI·Strapi·remoteStorage)를 domain 이음매에 맞춘다. 이 인스턴스들은 응답 객체를
// 돌려주므로 본문을 벗긴다. AI 인스턴스는 maxios 처럼 404 를 reject 하지 않고 AxiosError 로 resolve 하므로 reject 로 바꾼다.
const unwrap = async <T>(pending: Promise<unknown>): Promise<T> => {
  const res = await pending
  if (axios.isAxiosError(res)) return Promise.reject(res)
  return (res as { data: T }).data
}

const toAxiosConfig = ({ params, data, signal, withoutAuth, headers }: RequestConfig = {}) => ({
  params,
  data,
  signal,
  ...(headers && { headers }),
  ...(withoutAuth && { withoutAuth }),
  // meta·preventErrorToast·trackingProps 는 이 인스턴스들에 그것을 읽는 인터셉터가 없어 옮기지 않는다
})

export const toDomainHttpClient = (instance: AxiosInstance): HttpClient => ({
  get: (url, config) => unwrap(instance.get(url, toAxiosConfig(config))),
  post: (url, body, config) => unwrap(instance.post(url, body, toAxiosConfig(config))),
  put: (url, body, config) => unwrap(instance.put(url, body, toAxiosConfig(config))),
  patch: (url, body, config) => unwrap(instance.patch(url, body, toAxiosConfig(config))),
  delete: (url, config) => unwrap(instance.delete(url, toAxiosConfig(config))),
  getFile: async (url, config) => {
    const res = await instance.get<Blob>(url, { ...toAxiosConfig(config), responseType: 'blob' })
    if (axios.isAxiosError(res)) return Promise.reject(res)
    return {
      blob: res.data,
      fileName: parseContentDispositionFileName(res.headers['content-disposition']),
    }
  },
})
